import store from '@/store';
import DeviceType from '@/helpers/DeviceType';
import Tizen from './Tizen';
import LG from './LG';
//import Orsay from './Orsay';
import Orsay from './Tizen';
import RPI from './RPI';

export const SERVICE_TYPE = {
  TV: 'tv',
  RADIO: 'radio',
  INFO: 'info',
  UNKNOWN: 'unknown',
};

export const DVB_TYPE = {
  C: 'c',
  S: 's',
  T: 't',
  IP: '',
};

export const TV_STATUS = {
  LOADED: 'loaded',
  LOADING: 'loading',
  STARTED: 'started',
  READY: 'ready',
  CLOSED: 'closed',
};

export default class TV {
  static identifyChannel(channel) {
    if (channel.serviceType === SERVICE_TYPE.RADIO) {
      return SERVICE_TYPE.RADIO;
    }
    if (channel.serviceType === SERVICE_TYPE.TV) {
      return SERVICE_TYPE.TV;
    }
    if (channel.serviceType === SERVICE_TYPE.INFO) {
      return SERVICE_TYPE.INFO;
    }
    return SERVICE_TYPE.UNKNOWN;
  }

  static setChannel(channel, isNew) {
    const type = this.identifyChannel(channel);
    if (type === SERVICE_TYPE.UNKNOWN) {
      store.dispatch('notification/error', {
        title: 'Service Type not supported',
      });
      return;
    }

    if (DeviceType.isRPI) {
      RPI.setChannel(channel, type, isNew);
    } else if (DeviceType.isTizen) {
      Tizen.setChannel(channel, type, isNew);
    } else if (DeviceType.isLG) {
      LG.setChannel(channel, type, isNew);
    } else if (DeviceType.isOrsay) {
      Orsay.setChannel(channel, type, isNew);
    } else {
      store.dispatch('tv/setStatus', TV_STATUS.LOADED);
    }
  }

  static createPlayer(channel) {
    this.setChannel(channel);
  }

  static removePlayer(channel) {
    if (DeviceType.isTizen) {
      Tizen.removePlayer(channel);
    }
    if (DeviceType.isLG) {
      LG.removePlayer(channel);
    }
    if (DeviceType.isOrsay) {
      Orsay.removePlayer(channel);
    }
    if (DeviceType.isRPI) {
      RPI.removePlayer(channel);
    }
  }

  static turnOff() {
    if (DeviceType.isTizen) {
      Tizen.turnOff();
    }
    if (DeviceType.isLG) {
      LG.turnOff();
    }
    if (DeviceType.isOrsay) {
      Orsay.turnOff();
    }
  }
  static turnOn() {
    if (DeviceType.isTizen) {
      Tizen.turnOn();
    }
    if (DeviceType.isLG) {
      LG.turnOn();
    }
    if (DeviceType.isOrsay) {
      Orsay.turnOn();
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/TV/index.js